<template>
  <div class="services">
    <div class="header-wrap">
      <p class="header">
        Services we provide
      </p>
      <p class="desc gt-xs">
        We develop software for fintech companies<br/>
        used by thousands of users all around
      </p>
    </div>
    <div v-if="viewport.gt.sm" class="services-show" ref="servicesShow">
      <div class="floater" ref="floaterRef">
        <img :src="require(`@/assets/${slides[activeSlideIndex].img.sm}`)"
             alt="">
        <div class="floater-content">
          <div class="arrow-wrap arrow--white">
            <div class="arrow-tail"></div>
            <div class="arrow-tip"></div>
          </div>
          <p class="floater-title"
             ref="floaterTitleRef">
            <span v-html="slides[activeSlideIndex].title"
                  ref="floaterSpanRef">
            </span>
          </p>
          <p class="floater-desc" v-html="slides[activeSlideIndex].desc"></p>
        </div>
      </div>
      <div v-for="(slide, slideIndex) in slides"
           :key="`service-${slideIndex}`"
           :class="['slide',
                    `border-${slide.color}`,
                     activeSlideIndex === slideIndex ? 'active' : '']"
            @mouseenter="() => handleSlideHover(slideIndex)"
            ref="slidesRef">
        <img :src="require(`@/assets/${slide.img.sm}`)"
             alt="">
        <div class="slide-content">
          <div :class="['arrow-wrap', viewport.xs ? `arrow--white` : `arrow--${slide.color}`]">
            <div class="arrow-tail"></div>
            <div class="arrow-tip"></div>
          </div>
          <p class="slide-title" v-html="slide.title" ref='slideTitlesRef'></p>
          <p class="slide-desc" v-html="slide.desc"></p>
        </div>
      </div>
    </div>
    <carousel v-if="viewport.lt.md"
              autoWidth
              autoHeight
              :margin="20"
              :nav="false"
              loop
              :center="!viewport.xs"
              class="carousel--services">
      <div v-for="(slide, slideIndex) in slides"
           :key="`slide-${slideIndex}`"
           :class="['slide', `border-${slide.color}`]">
        <img :src="viewport.xs ?
                   require(`@/assets/${slide.img.xs}`) :
                   require(`@/assets/${slide.img.sm}`)"
             alt="">
        <div class="slide-content">
          <div :class="['arrow-wrap', viewport.xs ? `arrow--white` : `arrow--${slide.color}`]">
            <div class="arrow-tail"></div>
            <div class="arrow-tip"></div>
          </div>
          <p class="slide-title" v-html="slide.title"></p>
          <p class="slide-desc" v-html="slide.desc"></p>
        </div>
      </div>
    </carousel>
  </div>
</template>

<script>
import carousel from 'vue-owl-carousel';
import {
  TimelineMax, Power1, Power0,
} from 'gsap';

import { mapState } from 'vuex';

export default {
  name: 'Services',
  components: {
    carousel,
  },
  data() {
    return {
      slides: [
        {
          img: {
            xs: 'services_corporate_xs.png',
            sm: 'services_corporate.png',
          },
          title: 'Corporate <br/> websites',
          desc: 'We develop software for fintech companies used by thousands of users all around.',
          color: 'red',
        },
        {
          img: {
            xs: 'services_ecommerce_xs.png',
            sm: 'services_ecommerce.png',
          },
          title: 'E-commerce',
          desc: 'We develop software for fintech companies used by thousands of users all around.',
          color: 'blue',
        },
        {
          img: {
            xs: 'services_web_apps_xs.png',
            sm: 'services_web_apps.png',
          },
          title: 'Web apps',
          desc: 'We develop software for fintech companies used by thousands of users all around.',
          color: 'green',
        },
        {
          img: {
            xs: 'services_landing_pages_xs.png',
            sm: 'services_landing_pages.png',
          },
          title: 'Landing pages',
          desc: 'We develop software for fintech companies used by thousands of users all around.',
          color: 'orange',
        },
      ],
      activeSlideIndex: 0,
      isAnimating: false,
    };
  },
  computed: {
    ...mapState('viewport', ['viewport']),
    floaterLeft() {
      const { activeSlideIndex, floaterLeftMultiplier } = this;
      return activeSlideIndex * floaterLeftMultiplier;
    },
    floaterLeftMultiplier() {
      const { viewport: { md } } = this;
      // .slide width + margin right
      return md ? 240 : 335;
    },
  },
  methods: {
    handleSlideHover(slideIndex) {
      this.animate(slideIndex);
    },
    createTimeline(direction) {
      const { $refs: { floaterRef, floaterTitleRef } } = this;
      const tl = new TimelineMax();
      tl.timeScale(0.9);
      tl
        .to(floaterRef, 0.4, {
          x: this.floaterLeft,
          ease: Power1.easeOut,
        });
      if (direction === 'right') {
        tl
          .fromTo(
            floaterTitleRef,
            0.1,
            {
              transform: 'rotateY(35deg) scale(2) translateX(100%) translateY(40px)',
              transformOrigin: 'right',
              ease: Power0.easeNone,
            },
            {
              transform: 'rotateY(35deg) scale(2) translateX(30%) translateY(40px)',
              transformOrigin: 'right',
            },
            '-=0.3',
          )
          .to(floaterTitleRef, 0.3,
            {
              transform: 'rotateY(0) scale(1) translateX(0) translateY(0)',
            }, '-=0.3');
      } else {
        tl
          .fromTo(
            floaterTitleRef,
            0.1,
            {
              scale: 1.3,
              x: '-100%',
              y: '60px',
              ease: Power0.easeNone,
            },
            {
              scale: 1.3,
              x: '-30%',
              y: '60px',
            },
            '-=0.3',
          )
          .to(floaterTitleRef, 0.3,
            {
              x: '0%',
              y: '0px',
              scale: 1,
            }, '-=0.3');
      }
      tl.pause();
      return tl;
    },
    animate(slideIndex) {
      const { activeSlideIndex } = this;

      if (activeSlideIndex !== slideIndex) {
        const direction = activeSlideIndex < slideIndex ? 'right' : 'left';

        this.activeSlideIndex = slideIndex;
        this.tl = this.createTimeline(direction);
        this.tl.eventCallback('onComplete', () => {
          this.isAnimating = false;
        });
        this.tl.play();
        this.isAnimating = true;
      }
    },
  },
};
</script>


<style scoped lang="stylus">
  @import '../../styles/variables';

  .services{
    background: #f7f7f7;
    padding-left: 40px;
    padding-bottom: 25px;
    z-index: 610;
    padding-top: 290px;
    position: relative;
    top: -290px;
    margin-bottom: -290px;
  }

  .slide{
    width: 240px;
    height: 320px;
    position: relative;

    img{
      max-width: 100%;
    }

    .slide-content{
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 0 10px 30px 40px;
    }

    .slide-desc{
      display: none;
    }

    .slide-title{
      font-family: 'Dosis', sans-serif;
      font-weight: 200;
      font-size: 38px;
      color: #FFFFFF;
      line-height: 44px;
    }
  }

  .header{
    font-size: 24px;
    font-family: 'Dosis', sans-serif;
    font-weight: 600;
    padding: 40px 0 30px;
  }

  .arrow-wrap{
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 18px;

    .arrow-tail{
      width: 10px;
      height: 2px;
    }
    .arrow-tip{
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 4.5px 0 4.5px 7.8px;
    }
  }

  @media(min-width: $breakpoint-sm-min) {
    .services{
      padding-bottom: 60px;
    }
    .header-wrap{
      width: 480px;
      margin: 0 auto;
    }
    .header{
      font-size: 40px;
      padding-bottom: 35px;
      padding-top: 55px;
    }
    .desc{
      padding-bottom: 50px;
    }

    .slide{
      &.border-red{
        border: 1px solid #de5856;
        border-color: rgba(222,88,86, 0.2);
      }
      &.border-green{
        border: 1px solid #67aa6e;
        border-color: rgba(103,170,110, 0.2);
      }
      &.border-orange{
        border: 1px solid #eba457;
        border-color: rgba(235,164,87, 0.2);
      }
      &.border-blue{
        border: 1px solid #64bdf2;
        border-color: rgba(100,189,242, 0.2);
      }
    }
  }

  @media(min-width: $breakpoint-md-min) {
    .services{
      padding-left: 40px;
      padding-bottom: 40px;
      padding-top: 0;
      margin: 0 auto;
      top: -140px;
      margin-bottom: -140px;
      max-width: 1120px;
      background: none;
      position: relative;
      z-index: 613;

      &:before{
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 400px;
        background: #F7F7F7;
      }
    }

    .header-wrap{
      margin-left: 0;
      max-width: 360px;
      position: relative;
    }
    .header{
      font-size: 30px;
      padding-bottom: 20px;
    }
    .desc{
      font-size: 16px;
      line-height: 26px;
      padding-bottom: 40px;
    }

    .floater{
      width: 360px;
      height: 360px;
      position: absolute;
      left: 0;
      bottom: 0;
      // transition: left 0.6s;
      z-index: 612;

      img{
        max-width: 100%;
      }

      .floater-content{
        position: absolute;
        bottom: 0;
        left: 0;
        padding-bottom: 40px;
      }

      .floater-desc{
        display: block;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 26px;
        padding-left: 40px;
        padding-right: 40px;

      }

      .floater-title {
        font-size: 40px;
        color: #FFFFFF;
        line-height: 46px;
        margin-bottom 20px;
        padding-left: 40px;
        padding-right: 40px;
      }

      .arrow-wrap{
        position: relative;
        bottom: auto;
        right: auto;
        margin-bottom: 25px;
        padding-left: 40px;


        .arrow-tail{
          width: 20px;
          background: white !important;
        }
        .arrow-tip{
          border-color: transparent transparent transparent white !important;
        }
      }
    }

    .services-show{
      position: relative;
      display: flex;
      align-items: flex-end;
      height: 360px;
      perspective: 1000px;

      .slide.active{
        width: 200px;
        height: 200px;
        margin-left: 160px;
        overflow: hidden;
        &:last-child{
          margin-right: 0;
        }
      }

      .slide{
        width: 200px;
        height: 200px;
        background: white;
        transition: margin 0.6s;
        padding-left: 30px;
        padding-right: 30px;

        &:not(:last-child){
          margin-right: 40px;
        }

        .slide-title{
          color: #333333;
          font-size: 20px;
          line-height: normal;
        }

        .slide-content{
          top: 0;
          padding: 35px 40px;
        }

        .arrow-wrap{
          position: absolute;
          right: 40px;
          bottom: 35px;
          margin-bottom: 0;

          .arrow-tail{
            width: 15px;
          }
        }

        img{
          opacity: 0;
        }
      }
    }
  }

  @media(min-width: $breakpoint-lg-min) {
    .services{
      max-width: 1520px;
    }

    .header-wrap {
      .header {
        font-size: 40px;
      }
    }

    .services-show{
      height: 480px;

      .slide{
        &:not(:last-child){
          margin-right: 95px;
        }
      }

      .slide, .slide.active{
        width: 240px;
        height: 240px;
      }

      .slide.active{
        margin-left: 240px;
      }

      .floater{
        width: 480px;
        height: 480px;
      }
    }
  }

</style>

<style lang="stylus">
  @import '../../styles/variables';

  @media(min-width: $breakpoint-sm-min) {
    .carousel--services{

      .owl-theme .owl-nav.disabled + .owl-dots{
        margin-top: 60px !important;
      }

      .owl-stage{
        display: flex;
        justify-content: center;
        align-items: flex-end;
        height: 480px;
      }


      .owl-item{
        position: relative;
        z-index: 612;
        transition: margin 0.6s;

        .slide{
          width: 240px;
          height: 240px;
          overflow: hidden;
          background: white;
          transition: transform 0.6s;
          transform-origin: center bottom;


          .slide-title{
            color: #333333;
            font-size: 30px;
            line-height: normal;
          }

          .slide-content{
            top: 0;
            padding: 35px 40px;
          }

          .arrow-wrap{
            position: absolute;
            right: 40px;
            bottom: 35px;
            margin-bottom: 0;

            .arrow-tail{
              width: 15px;
            }
          }

          img{
            opacity: 0;
          }
        }
      }

      .owl-carousel:not(.owl-grab){
        .owl-item.active.center{
          position: relative;
          z-index: 613;
          margin-left: 120px;
          margin-right: 140px !important;

          .slide{
            transform: scale(2);
            border: 0;

            img{
              opacity: 1;
            }

            .slide-content{
              transform: scale(0.5);
              transform-origin: center bottom;
              width: 480px;
              left: -120px;
              right: auto;
              top: auto;
              bottom: 0;
              padding-left: 65px;
              padding-right: 100px;
              padding-bottom: 50px;
            }

            .slide-title{
              color: white;
              margin-bottom: 20px;
              font-size: 50px;
              line-height: 60px;
            }

            .slide-desc{
              display: block;
              font-size: 15px;
              color: white;
              line-height: 31px;
            }

            .arrow-wrap{
              position: static;
              margin-bottom: 30px;

              .arrow-tail{
                width: 30px;
                background: white;
              }
              .arrow-tip{
                border-color: transparent transparent transparent white;
              }
            }
          }
        }

      }

    }
  }
</style>
